const PropTypes = require('prop-types');
// @ vendor
const React = require('react');

// @ components
const { BrokerProductFileHeader } = require('components/broker/brokerStocksLikeHeader/brokerStocksLikeHeader');

const BrokerStocksHeader = props => {
    return (
        <BrokerProductFileHeader
            modifier="stocks"
            {...props}
        />
    );
};

BrokerStocksHeader.propTypes = {
    getProductDetails: PropTypes.func,
    match: PropTypes.object,
    productFile: PropTypes.object,
    immMyInvestments: PropTypes.object.isRequired,
    noBottomButtons: PropTypes.bool,
    fireTaggingBuyButton: PropTypes.func
};

module.exports = BrokerStocksHeader;
